import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=56d496bc"
import script from "./EmailPreview.vue?vue&type=script&lang=js"
export * from "./EmailPreview.vue?vue&type=script&lang=js"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=56d496bc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d496bc')) {
      api.createRecord('56d496bc', component.options)
    } else {
      api.reload('56d496bc', component.options)
    }
    module.hot.accept("./EmailPreview.vue?vue&type=template&id=56d496bc", function () {
      api.rerender('56d496bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailPreview.vue"
export default component.exports